import moment from "moment";
import { ReportSettingsModel } from "../exportModels";
import { PractitionerAtLocationStatuses } from "../enumerations";
import { ReportPanelBodyBaseState } from "./reportPanelBodyBase";
import ExportService from "../exportService";

function stringifyStateReportSettings(state: ReportPanelBodyBaseState): string {
  const { loadingReportSettingsJSONStrings, ...stateReportSettings } = state;
  return JSON.stringify(stateReportSettings);
}

function tryParseReportSettings(settings: string): Record<string, unknown> {
  if (settings) {
    try {
      return JSON.parse(settings);
    } catch (e) {
      return null;
    }
  }  
}

function reportName(prefix: string): string {
  const now = moment();
  return `${prefix}_${now.format("YYYYMMDD[_]HHmmss")}`;
}

function defaultPractitionerAtLocationStatuses(closedLocationsEnabled: boolean, samePracticeDifferentAddressEnabled = false): PractitionerAtLocationStatuses[] {
  return Object.values(PractitionerAtLocationStatuses)
    .filter((status) => closedLocationsEnabled || status !== PractitionerAtLocationStatuses.LocationClosed)
    .filter((status) => samePracticeDifferentAddressEnabled || status !== PractitionerAtLocationStatuses.SamePracticeDifferentAddress);
}

const saveNewReportSettings = async (rs: ReportSettingsModel): Promise<ReportSettingsModel> => {
  const exportService = new ExportService();
  return await exportService.saveReportSettings(rs);
}

const saveUpdatedReportSettingsList = async (rs: ReportSettingsModel[]): Promise<boolean> => {
  const exportService = new ExportService();
  return await exportService.updateReportSettings(rs);
}

const deleteReportSettings = async (ids: number[]): Promise<boolean> => {
  const exportService = new ExportService();
  return await exportService.deleteReportSettings(ids);
}

function resolveNewProviderReportRunState(params: {
  hasNoPublishedRun: boolean;
  isLatestPublished: boolean;
  isSelectedRunPublished: boolean;
}): {
  isViewingNonCurrentRun: boolean;
  isViewingPastRun: boolean;
  isViewingUnpublishedRun: boolean;
} {
  const isViewingNonCurrentRun = !params.hasNoPublishedRun && !params.isLatestPublished;
  return {
    isViewingNonCurrentRun,
    isViewingPastRun: isViewingNonCurrentRun && params.isSelectedRunPublished,
    isViewingUnpublishedRun: isViewingNonCurrentRun && !params.isSelectedRunPublished,
  };
}

export {
  defaultPractitionerAtLocationStatuses,
  deleteReportSettings,
  resolveNewProviderReportRunState,
  saveNewReportSettings,
  saveUpdatedReportSettingsList,
  stringifyStateReportSettings,
  tryParseReportSettings,
  reportName,
};
